export const PRODUCT_PRICES = {
    google_discover_analytics: 99,
    google_search_analytics: 49,
    ai_tracking: 49 / 500, // per prompt
    commerce: 399,
    additional_seats_per_domain: 5,
};

export const DATA = [
    {
        category: 'ai_analytics',
        features: [
            {
                title: 'Platform Coverage',
                description:
                    "Monitor your brand's visibility across major AI platforms including ChatGPT, Gemini, Perplexity, and Google AI Overviews",
            },
            {
                title: 'Stable Data Ingestion',
                description:
                    'Ensure consistent tracking and platform runs by indexing your data with dataset IDs rather than just URLs',
            },
            {
                title: 'Prompt Mapping',
                description:
                    'Track AI-influenced visibility internally without relying on clickstream data by mapping your entities and topics to specific prompts',
            },
            {
                title: 'Prompt Clusters',
                description:
                    "Organize your data to create prompt clusters and track your brand's performance across those targeted groups",
            },
            {
                title: 'Daily Tracking',
                description:
                    'Automate your AI strategy by running and tracking your targeted prompts on a daily basis',
            },
            {
                title: 'Citation Reporting',
                description:
                    'Receive detailed reports on your specific citations and mentions generated by the AI platforms',
            },
            {
                title: 'Content Efficiency',
                description:
                    'Track the exact share of your published articles that successfully trigger an AI Overview and measure their associated visibility',
            },
            {
                title: 'Optimization Integration',
                description:
                    'Take advantage of planned third-party API integrations that will provide actionable recommendations for prompt optimization',
            },
        ],
    },
    {
        category: 'google_discover_analytics',
        features: [
            {
                title: 'Four Optimization Pillars',
                description:
                    'Structure your optimization strategy around Categories, Entities, Authors, and Content Characteristics to guide repeatable Discover wins',
            },
            {
                title: 'Live Discover Optimization',
                description:
                    'Track newly published articles in near real-time and receive AI-assisted headline and image recommendations to instantly improve your click-through rates',
            },
            {
                title: 'Historical Rinse-and-Repeat',
                description:
                    'Analyze your historical performance to systematically repeat the topics, formats, and headline structures that have previously worked',
            },
            {
                title: 'Entity-Based Tracking',
                description:
                    'Transition from keyword-centric strategies to entity-driven optimization that mirrors how modern Google surfaces and ranks content',
            },
            {
                title: 'Category Deep-Dives',
                description:
                    'Find high-yield, low-volume topics by comparing your categories based on total scale versus median impressions per article',
            },
            {
                title: 'Author Analytics',
                description:
                    'Measure writer-level impact by comparing total output against per-article efficiency to double down on your highest-ROI authors',
            },
            {
                title: 'Content Insights Analyzer',
                description:
                    'Automatically extract successful content themes, high-impact keywords, and CTR-boosting headline patterns from your top-performing articles within minutes',
            },
            {
                title: 'Discover Feed Simulation',
                description:
                    'Surface trending articles across different demographics and geographies by simulating user behavior and device profiles',
            },
        ],
    },
    {
        category: 'search_analytics',
        features: [
            {
                title: 'Unified GSC Views',
                description:
                    'Simplify your performance monitoring by combining seven different Google Search Console reports into one holistic dashboard',
            },
            {
                title: 'Weekly Keyword Clusters',
                description:
                    'Automatically group your Search Console keywords into weekly clusters to easily visualize thematic growth, decline, and momentum',
            },
            {
                title: 'Evergreen Decay Detector',
                description:
                    'Automatically flag older, evergreen pages that have experienced significant traffic drops so you know exactly what to update or redirect',
            },
            {
                title: 'Refresh Alerting',
                description:
                    "Receive a notification when an article's current clicks drop beyond a defined threshold compared to its historical maximum",
            },
            {
                title: 'Article ID Performance',
                description:
                    'Accurately consolidate your reporting metrics across multiple URL or slug changes by tracking a stable article ID',
            },
            {
                title: 'Striking-Distance Alerts',
                description:
                    "Automatically surface long-tail, low-difficulty keywords and 'almost-there' ranking opportunities to grab quick SEO wins",
            },
            {
                title: 'Entity-Level Clustering',
                description:
                    'Group your URLs and keywords by shared meaning and search intent, rather than just syntax, to guide editorial planning',
            },
            {
                title: 'Pruning Recommendations',
                description:
                    "Evaluate your site's URLs to receive automated keep, review, or redirect classifications to improve overall site quality and authority concentration",
            },
        ],
    },
    {
        category: 'commerce',
        features: [
            {
                title: 'Commerce Topic Analysis',
                description:
                    'Analyze thousands of high-volume commercial keywords per topic—like mattresses, furniture, or skincare—to guide your strategy',
            },
            {
                title: 'Competitor Benchmarking',
                description:
                    'Compare your Google Discover and Search performance directly against competitors based on over one trillion indexed impressions',
            },
            {
                title: 'Commerce Market Share',
                description:
                    'Map your exact share of the search engine results page (SERP) to identify high-impact clusters for affiliate and product content',
            },
            {
                title: 'Content Gap Identification',
                description:
                    'Uncover specific, revenue-driving content gaps that you are missing compared to your competitors',
            },
            {
                title: 'Opportunity Scoring',
                description:
                    'Generate customized, cluster-level opportunity scores specifically designed to support your affiliate and product content efforts',
            },
            {
                title: 'High-CPC Detection',
                description:
                    "Directly support your site's monetization strategy by automatically detecting and targeting high-CPC (cost-per-click) keywords",
            },
            {
                title: 'Gift-Guide Mapping',
                description:
                    'Align your SEO planning with strong affiliate intent by optimizing your content mapping for profitable gift guides',
            },
            {
                title: 'Display Revenue Enhancement',
                description:
                    'Drive better display ad impressions and user engagement by optimizing your overall SEO reach',
            },
        ],
    },
];

export const PRODUCTS = {
    ai_tracking: 'AI Tracking',
    discover_analytics: 'Google Discover',
    search_analytics: 'Google Search',
    commerce_analytics: 'Commerce Analytics',
};
